/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const UPGRADE_EFFECT_POPOVER_ID = 'upgrade_effect_popover'


export const COMMAND_CENTER_LEVEL_HEADER = (
    <FormattedMessage
        id='upgrade_effect_popover.command_center_level_header'
        defaultMessage='Уровень Коммандного центра'
    />
)

export const REQUIRED_BUILDINGS_LEVEL_SUMM_HEADER = (
    <FormattedMessage
        id='upgrade_effect_popover.required_buildings_level_summ_header'
        defaultMessage='Суммарный уровень строений'
    />
)

export const UPGRADE_COMMAND_CENTER_COST_HEADER = (
    <FormattedMessage
        id='upgrade_effect_popover.upgrade_command_center_cost_header'
        defaultMessage='Стоимость модернизации'
    />
)

export const PERMISSIONS_REQUIRED_MESSAGE = (
    <FormattedMessage
        id='upgrade_effect_popover.command_center_permissions_required_message'
        defaultMessage='Модернизировать Командный центр могут командующий и его заместители'
    />
)

export const UPGRADE_COMMAND_CENTER_DECRIPTION = (level) => (
    <FormattedMessage
        id='upgrade_effect_popover.upgrade.command_center_description'
        defaultMessage='Модернизация Командного центра позволит модернизировать остальные строения до {level} уровня'
        values={{
            level,
        }}
    />
)

export const MAX_COMMAND_CENTER_LEVEL_MESSAGE = (
    <FormattedMessage
        id='upgrade_effect_popover.max_command_center_level_message'
        defaultMessage='Командный центр модернизирован до максимального уровня'
    />
)

export const COMMAND_CENTER_UPGRADE_TABLE_TITLE = (
    <FormattedMessage
        id='upgrade_effect_popover.command_center_upgrade_table_title'
        defaultMessage='Условия модернизации командного центра в зависимости от его уровня'
    />
)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/UpgradeEffectContent/constants.jsx